import BundleVersionDAO from '../../modules/distribution/components/bundle/version/DAO/BundleVersionDAO';

export default class SignBundleVersionService {

    constructor(JFrogModal, JFrogEventBus, JFrogNotifications, bundleVersionDAO, $rootScope) {
        this.modal = JFrogModal;
        this.$rootScope = $rootScope;
        this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.jfrogNotifications = JFrogNotifications;
        this.bundleVersionResource = bundleVersionDAO.Resource;
    }


    signBundleVersion(daoParams, customAction) {
        this.customAction = customAction;
        this.daoParams = daoParams;
        this.modalScope = this.$rootScope.$new();
        this.modalScope.release_bundle_version = daoParams.release_bundle_version;
        this.modalScope.release_bundle = daoParams.release_bundle;
        this.modalScope.isPassphraseRequired = false;
        this.modalScope.data = {
            passPhrase: null
        };
        this.modalScope.sign = this.sign.bind(this);

        // Async call to check if has gpg key - and only then show modal
        this.bundleVersionResource.isPassphraseRequired().$promise.then((response) => {
            this.modalScope.isPassphraseRequired = (response.passphrase_required);
        }).finally(()=>{
            this.modalInstance = this.modal
                    .launchModalWithTemplateMarkup(require('./sign.bundle.version.modal.template.html'),
                            this.modalScope, 600, false);
        });

    }

    sign() {
        if(this.customAction && typeof this.customAction === 'function') {
            this.customAction(this.modalScope.data.passPhrase);
            this.modalInstance.close();
        } else {
            if(this.modalScope.data.passPhrase) {
                this.bundleVersionResource.sign.setHeaders('X-GPG-PASSPHRASE', this.modalScope.data.passPhrase);
            }
            this.bundleVersionResource
                    .sign(this.daoParams,{}).$promise
                    .then(() => {
                        this.jFrogEventBus.dispatch(this.EVENTS.VERSION_SIGNED);
                        this.modalInstance.close();
                    }).finally(()=>{
                this.bundleVersionResource.sign.removeHeaders();
            })
        }
    }
}

SignBundleVersionService.META = {
    name: 'SignBundleVersionService'
};

SignBundleVersionService.$inject = [
    'JFrogModal',
    'JFrogEventBus',
    'JFrogNotifications',
    BundleVersionDAO.META.name,
    '$rootScope'];



// WEBPACK FOOTER //
// ./modules/distribution/services/signBundleVersionService/sign.bundle.version.service.js